import React, { useState } from 'react';


import DemoAccountForm from '../Forms/DemoAccountForm';
import LiveAccountForm from '../Forms/LiveAccountForm';

import Switch from '@material-ui/core/Switch';

const FormPage = () => {
  const [state, setState] = useState({ checkedB: true });

  // const handleChange = (event) => {
  //   setState({ ...state, [event.target.name]: event.target.checked });
  // };
  const [checked, setChecked] = useState(false);
  const handleChange = () => {
    setChecked(!checked);
  };


  return (
    <section className='section'>
      <div className=" container mx-auto mb-10 lg:mb-20 text-center text-black"
        data-aos='fade-down'
        data-aos-delay='500'>
        <h4 className='h2 mb-10 lg:mb-20 text-center text-black'>Fill-up form to get
          FREE EA</h4>
        {/* <span>Demo Account Form</span>
        <Switch
          checked={state.checkedB}
          onChange={handleChange}
          color="primary"
          name="checkedB"
          className=' animate-bounce'
        />
        <span>Live Account Form</span>
        {state.checkedB ? <LiveAccountForm /> : <DemoAccountForm />} */}


        <div className="switch-button mx-auto bg-gray-200">
          <input className="switch-button-checkbox" type="checkbox" checked={checked} onChange={handleChange}></input>
          <label className="switch-button-label" for="">
            <span className="switch-button-label-span text-black" >Demo</span>
          </label>
        </div>
        {checked ? <LiveAccountForm /> : <DemoAccountForm />}





      </div>

    </section>

  )
}

export default FormPage
